import React, {useState, useEffect} from 'react'
import './Sliderstyle.css'
import SliderData from './SliderData'
import {AiOutlineArrowLeft, AiOutlineArrowRight} from 'react-icons/ai' 
import { LazyLoadImage, } from 'react-lazy-load-image-component';



const Slider = () => {

    const [currentSlide, setCurrentSlide] = useState (0)

    const slideLength = SliderData.length;
    //slide lenght = 1 2 3
    //current slide = 0 1 2

    // Set sliders next and prev
    const nextSlide = () => {
        setCurrentSlide(currentSlide === slideLength -1 ? 0 : currentSlide + 1);
    }
    
    const prevSlide = () => {
        setCurrentSlide(currentSlide === 0 ? slideLength -1 : currentSlide -1 );
    }
    
    //timer for autoscroll
    
        const autoScroll = true;
        let slideInterval;
        let intervalTime = 10000;
    
        function auto() {
            slideInterval = setInterval(nextSlide, intervalTime)
        }

    useEffect(() => {
        setCurrentSlide(0)
    }, []);

    useEffect (() =>{
        if (autoScroll) {
            auto();
        }
        return () => clearInterval(slideInterval);
    }, [currentSlide]);

  return (
    <div className="slider w-100">
        <AiOutlineArrowLeft className='arrow prev' onClick={prevSlide}/>
        <AiOutlineArrowRight className='arrow next' onClick={nextSlide}/>

        {SliderData.map((slide, index) => {
            return (
                <div className={index === currentSlide ? "slide current w-100" : "slide"} key ={index}>
                    {index === currentSlide && (
                        <div>
                        <LazyLoadImage
                            className='image' 
                            src={slide.imagesource} 
                            alt="images" 
                            effect="blur"
                            threshold={100}/>

                        <div className='playdetail'>
                            <h4 className='text-secondary'>PLAYLIST</h4>
                            <h2>{slide.title}</h2>
                            <p>{slide.text}</p>
                            <p className='text-secondary mt-3'>curated by: @tropicalmonroe</p>
                            <hr/>
                            </div>
                            
</div>
                    )}
                </div>
            )
        })}

    </div>
  )
}

export default Slider